import { Injectable } from '@angular/core';
import { RoleGuard } from './role.abstract.guard';

@Injectable({ providedIn: 'root' })
export class ComercialGuard extends RoleGuard {
  role: string[] = ['comercial'];
}
